import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'
import { cn } from '../lib/utils'

const SegmentedTabs = TabsPrimitive.Root

interface SegmentedTabsListProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> {
  className?: string
}

const SegmentedTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  SegmentedTabsListProps
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'no-scrollbar flex w-full items-center justify-start overflow-x-auto rounded-md bg-[#F0F0FF] p-1',
      className
    )}
    {...props}
  />
))
SegmentedTabsList.displayName = 'SegmentedTabsList'

interface SegmentedTabsTriggerProps extends React.ComponentPropsWithoutRef<
  typeof TabsPrimitive.Trigger
> {
  className?: string
}

const SegmentedTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  SegmentedTabsTriggerProps
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'flex flex-1 cursor-pointer items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-all',
      'text-[#5B476B] hover:bg-[#E6E6FF] focus-visible:ring-2 focus-visible:ring-indigo-400 focus-visible:ring-offset-2 focus-visible:outline-none',
      'disabled:pointer-events-none disabled:opacity-50',
      'data-[state=active]:bg-white data-[state=active]:text-[#5B476B] data-[state=active]:shadow-sm',
      className
    )}
    {...props}
  />
))
SegmentedTabsTrigger.displayName = 'SegmentedTabsTrigger'

interface SegmentedTabsContentProps extends React.ComponentPropsWithoutRef<
  typeof TabsPrimitive.Content
> {
  className?: string
}

const SegmentedTabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  SegmentedTabsContentProps
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'focus-visible:ring-2 focus-visible:ring-indigo-400 focus-visible:ring-offset-2 focus-visible:outline-none',
      className
    )}
    {...props}
  />
))
SegmentedTabsContent.displayName = 'SegmentedTabsContent'

export { SegmentedTabs, SegmentedTabsContent, SegmentedTabsList, SegmentedTabsTrigger }
